import styled from "styled-components";
import { FormLabel } from "../../../components/forms";

const SectionHeader = styled(FormLabel)`
    margin-top: 1.5rem;
    text-decoration: underline;
    font-size: 0.875rem;
`;

export default SectionHeader